import React, { useState, useEffect } from "react";
import "../App.css";
import { TextField, Button } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { useRecaptcha } from "./hook/useRecaptcha";

import logo from "../img/logo_transparent.png";

import {
  getAuth,
  getMultiFactorResolver,
  PhoneAuthProvider,
  PhoneMultiFactorGenerator,
  RecaptchaVerifier,
  signInWithEmailAndPassword,
} from "firebase/auth";

export default function Login() {
  const auth = getAuth();
  let recaptchaVerifier = useRecaptcha("recaptcha");

  const navigate = useNavigate();

  const [pass, setpass] = useState("");
  const [email, setemail] = useState("");

  let login = () => {
    signInWithEmailAndPassword(auth, email, pass)
      .then(function (userCredential) {
        alert("You are not verfied! Contact Admin.");
      })
      .catch(function (error) {
        if (error.code == "auth/multi-factor-auth-required") {
          const resolver = getMultiFactorResolver(auth, error);
          // Ask user which second factor to use.
          if (
            resolver.hints[0].factorId === PhoneMultiFactorGenerator.FACTOR_ID
          ) {
            const phoneInfoOptions = {
              multiFactorHint: resolver.hints[0],
              session: resolver.session,
            };
            const phoneAuthProvider = new PhoneAuthProvider(auth);
            // Send SMS verification code
            return phoneAuthProvider
              .verifyPhoneNumber(phoneInfoOptions, recaptchaVerifier)
              .then(function (verificationId) {
                // Ask user for the SMS verification code. Then:
                let verificationCode = prompt("Enter Verifictaion Code");
                const cred = PhoneAuthProvider.credential(
                  verificationId,
                  verificationCode
                );
                const multiFactorAssertion =
                  PhoneMultiFactorGenerator.assertion(cred);
                // Complete sign-in.
                return resolver.resolveSignIn(multiFactorAssertion);
              })
              .then(function (userCredential) {
                // User successfully signed in with the second factor phone number.
                navigate("/home");
              })
              .catch((e) => {
                alert(e);
                console.log(e);
              });
          }
        } else if (error.code == "auth/wrong-password") {
          // Handle other errors such as wrong password.
          alert("Wrong Pass");
        }
      });

    // if((email == "joe" && pass == "joe") || (email == "Brian" && pass == "Marleybobs87540") || (email == "Stella" && pass == "Marleybobs88!") || (email == "Janine" && pass == "Amelia123") || (email == "Lynne" && pass == "LMA081162") || (email == "Rob" && pass == "Moses88!") || (email == "Amanda" && pass == "Moses87540") || (email == "PatG" && pass == "John3:16")){
    //     navigate("/home");
    // }else{
    //     alert("Please Check you email and Password")
    // }
  };

  return (
    <div className="loginMain">
      <div className="LoginPage1">
        <div
          style={{
            backgroundColor: "#ffffff",
            width: "300px",
            height: "180px",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            borderRadius: "10px",
            marginBottom: "30px",
          }}
        >
          <img src={logo} height="120" />
        </div>
        <TextField
          inputProps={{ style: { fontSize: 20 } }}
          InputLabelProps={{ style: { fontSize: 20 } }}
          placeholder="Email"
          className="LoginForm"
          id="outlined-basic"
          variant="outlined"
          onChange={(e) => setemail(e.target.value)}
        />

        <TextField
          inputProps={{ style: { fontSize: 20 } }}
          InputLabelProps={{ style: { fontSize: 20 } }}
          type="password"
          className="LoginForm"
          id="outlined-basic"
          placeholder="Password"
          variant="outlined"
          onChange={(e) => setpass(e.target.value)}
        />
        <div id="recaptcha"></div>
        <Button onClick={login} className="LoginForm" variant="outlined">
          LOGIN
        </Button>
      </div>
    </div>
  );
}
